import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import ThumbHtmlView from './CommissionHtml';
import ThumbReactView from './Commission';
const CommissionThumbView = (props)=>{
    if (props.isHtml) {
        return /*#__PURE__*/ React.createElement(ThumbHtmlView, _extends({}, props));
    }
    return /*#__PURE__*/ React.createElement(ThumbReactView, _extends({}, props));
};
CommissionThumbView.displayName = 'CommissionThumbView';
export default CommissionThumbView;
